// Import images from assets folder
import dashSeller from "../../images/seller-net-icon.svg";
import dashBuyer from "../../images/buyer-icon.svg";
import dashSellertwo from "../../images/seller2net.svg";
import dashRefinance from "../../images/refinance-icon.svg";
import dashOpen from "../../images/open-previously.svg";
import proposition from "../../images/proposition.svg";
import userProfile from "../../images/profle.jpg";
import registersuccess from "../../images/success-check.svg";
import contactpinlocation from "../../images/pin-location-map-svgrepo-com.svg";
import propertypicturea from "../../images/pics-a.png";
import propertypictureb from "../../images/pics-b.png";
import removeicon from "../../images/remove-icon.svg";
import quickcalc from "../../images/quick-quote.svg";

// Export as an object
const Imageimport = {
  dashSeller,
  dashBuyer,
  dashSellertwo,
  dashRefinance,
  dashOpen,
  quickcalc,
  userProfile,
  proposition,
  registersuccess,
  contactpinlocation,
  propertypicturea,
  propertypictureb,
  removeicon,
};

export default Imageimport;
